interface QuoteBlockProps {
  content: {
    quote?: string;
    attribution?: string;
  };
}

export function QuoteBlock({ content }: QuoteBlockProps) {
  if (!content.quote) return null;

  return (
    <section className="mx-auto max-w-[1200px] px-6 py-20">
      <div className="border-l-2 border-foreground/20 pl-8 max-w-[800px] mx-auto">
        <blockquote className="font-serif text-xl md:text-2xl text-foreground leading-relaxed italic">
          "{content.quote}"
        </blockquote>
        {content.attribution && (
          <cite className="block mt-4 font-sans text-sm text-muted-foreground not-italic">
            — {content.attribution}
          </cite>
        )}
      </div>
    </section>
  );
}
